import { Splide, SplideSlide } from '@splidejs/react-splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import { brokerLogoCarouselItems, options } from './configs';
import _ from 'lodash';

const BrokerCarousel = () => {
  return (
    <section className="broker-carousel">
      <div>
        <p className="broker-carousel__header">Integrated with Leading Brokers</p>
        <div className="gray-gradient-line"></div>
      </div>
      <div className="broker-carousel__content">
        <div className="right-blur" />
        <div className="left-blur" />
        <Splide
          options={options}
          extensions={{ AutoScroll }} // Use the AutoScroll extension
        >
          {_.map(brokerLogoCarouselItems, (item) => (
            <SplideSlide key={_.uniqueId('broker-logo-')}>
              <img src={_.get(item, 'src')} alt={_.get(item, 'alt')} />
            </SplideSlide>
          ))}
        </Splide>
      </div>
    </section>
  );
};

export default BrokerCarousel;
